import { INTERCOM_TOURS_PATHS } from 'app-constants'
import { sanitize } from 'dompurify'
import config from 'config'

export const getWhitelabelColor = state =>
  state.global.embedded ? 'dimgray' : undefined

const getCompanyFeatures = company => {
  if (!company || !company.features) {
    return {}
  }

  const features = {}
  Object.keys(company.features).map(key => {
    features[`features_${key}`] = company.features[key]
  })
  return features
}

export const addEmailFromattingToPreview = (message, branding) => {
  const recRightButtonRegex = /\{#((.*recright.com.*?))\|((.*?))\#}\n?/g
  const recRightRuButtonRegex = /\{#((.*recright.ru.*?))\|((.*?))\#}\n?/g
  const surveyMonkeyButtonRegex = /\{#((.*surveymonkey.com.*?))\|((.*?))\#}\n?/g
  const twitterLinkRegex = /\[(.*\/\/twitter.com.*?)\|((.*?))\]\n?/g
  const recRightLinkRegex = /\[(.*recright.com.*?)\|((.*?))\]\n?/g
  const recRightRuLInkRegex = /\[(.*recright.ru.*?)\|((.*?))\]\n?/g
  const hubspotLinkRegex = /\[(.*hubspotusercontent-na1.net.*?)\|((.*?))\]\n?/g
  const intercomLinkRegex = /\[(.*intercom-help.eu\/recright\/.*?)\|((.*?))\]\n?/g
  const linkRegex = /\[(http:\/\/.*?|https:\/\/.*?)\|(.*?)\]\n?/g
  const inlineLinkRegex = /\(#(.*?)\|(.*?)#\)\n?/g
  const boldedRegex = /\*(.*?)\*/g
  const cursiveRegex = /(?<!http:\/\/|https:\/\/|www\.|http:\/\/[^\s]*|https:\/\/[^\s]*|www\.[^\s]*)\_(?!http:\/\/|https:\/\/|www\.|http:\/\/[^\s]*|https:\/\/[^\s]*|www\.[^\s]*)((?:(?!http:\/\/|https:\/\/|www\.).)*?)\_/g // Modified regex to avoid affecting URLs
  const paragraphRegex = /\$(.*?)\$/g
  const newlineRegex = /\n/g
  const emailRegex = /([A-Za-z0-9\x27\x2f!#$%&*+=?^_`{|}~-]+(\.[A-Za-z0-9\x27\x2f!#$%&*+=?^_`{|}~-]+)*)@(([a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9]|[a-zA-Z0-9]{1,63})(\.([a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9]|[a-zA-Z0-9]{1,63}))*\.[a-zA-Z0-9]{2,63})/g
  const linkReplacement = `<a href="#" style="font-family: Open Sans, sans-serif; font-size: 14px; color: ${branding.brandColor}; text-decoration: none;">$2</a>`
  const cursiveReplacement = `<i style="font-family: Open Sans, sans-serif; font-size: 14px; color: ${branding.textColor}; text-align:left; line-height: 24px; margin: 0px;">$1</i>`
  const paragraphReplacement = `<p style="font-family: Open Sans, sans-serif; font-size: 12px; color: ${branding.textColor}; text-align:left; line-height: 18px; margin: 0px;">$1</p>`
  const strongReplacement = `<b style="font-family: Open Sans, sans-serif; font-size: 14px; color: ${branding.textColor}; text-align:left; line-height: 24px; margin: 0px;">$1</b>`
  const newlineReplacement = '<br>'
  const emailReplacement = `<a href="mailto:#" style="font-family: Open Sans, sans-serif; font-size: 14px; line-height: 24px; color: ${branding.brandColor}; text-decoration:none;">$&</a>`
  const buttonReplacement =
    '<table width="100%" align="center" valign="middle" border="0" cellpadding="0" cellspacing="0" st-button="learnmore"><tbody>' +
    '<tr><td height="20" align="center" style="font-size:1px; line-height:1px;">&nbsp;</td></tr>' +
    `<tr><td height="50" align="center" valign="middle"><table border="0" cellspacing="0" cellpadding="0"><tr><td bgcolor="${branding.brandColor}" style="-webkit-border-radius:24px; min-width: 80px; border-radius:24px; padding: 1px;" align="center" st-title="fulltext-btn"><a target="_blank" style="font-size: 16px; line-height: 24px; font-family: Open Sans, sans-serif; font-weight: normal; color: ${branding.buttonTextColor}; text-decoration: none; padding: 8px 16px; display: inline-block;" href="#">$3</a></td></tr></table></td></tr>` +
    '<tr><td height="10" align="center" style="font-size:1px; line-height:1px;">&nbsp;</td></tr>' +
    `<tr><td height="10" align="center" style="font-size:11px; line-height:1px;"><a href="#" style="font-family: Open Sans, sans-serif; font-size: 12px; color: ${branding.textColor} !important; line-height: 18px !important; cursor: copy!important; text-decoration:none!important;">$1</a></td></tr>` +
    '<tr><td height="20" align="center" style="font-size:1px; line-height:1px;">&nbsp;</td></tr></tbody></table>'

  const HTMLMessage = message
    .replace(recRightButtonRegex, buttonReplacement)
    .replace(recRightRuButtonRegex, buttonReplacement)
    .replace(surveyMonkeyButtonRegex, buttonReplacement)
    .replace(twitterLinkRegex, linkReplacement)
    .replace(recRightLinkRegex, linkReplacement)
    .replace(recRightRuLInkRegex, linkReplacement)
    .replace(hubspotLinkRegex, linkReplacement)
    .replace(intercomLinkRegex, linkReplacement)
    .replace(inlineLinkRegex, linkReplacement)
    .replace(newlineRegex, newlineReplacement)
    .replace(linkRegex, linkReplacement)
    .replace(boldedRegex, strongReplacement)
    .replace(cursiveRegex, cursiveReplacement)
    .replace(paragraphRegex, paragraphReplacement)
    .replace(emailRegex, emailReplacement)
  return sanitize(HTMLMessage)
}

export const getCompanyActiveFeatures = company => {
  const hasCustomBranding = company && company.features && company.features.branding && company.branding && Object.keys(company.branding).length > 0
  const companyEmailTemplates = company && company.emailTemplates
  const hasCustomVideoBg = company && company.videoBackgroundImages && company.videoBackgroundImages.length > 0
  const hasCustomEmailTemplates = companyEmailTemplates && Object.keys(companyEmailTemplates).map(key => companyEmailTemplates[key].length > 0).includes(true)
  // add here the customCompanyBg after it's released
  return { hasCustomBranding, hasCustomEmailTemplates, hasCustomVideoBg }
}

export const getCompanyAndInterviewInfoForAmplitude = interview => {
  const company = interview && interview.company
  const interviewInfo = {
    interviewId: interview && interview._id,
    interviewType: interview && interview.type,
    isEmbedded: interview && interview.isEmbedded,
    isPublic: interview && interview.isPublic,
    language: interview && interview.language,
  }

  const companyInfo = company
    ? {
        companyId: company._id,
        companyName: company.name,
        companyIntegration: company.integrationType,
      }
    : {}

  return { ...companyInfo, ...interviewInfo }
}

export const getCandidateInfoForAmplitude = candidate => {
  const candidateInfo = candidate
    ? {
      candidateId: candidate._id,
      candidateUuid: candidate.uuid,
      candidateState: candidate.state,
      isPublicInterviewCandidate: candidate.fromPublic,
    }
    : {}

  return candidateInfo
}

export const getCurrentRoutePath = routes => {
  const path = routes.length > 0 && routes.map(({ path }) => path).join('/')
  return path
}

const getSubscriptionAndSubscriptionStatus = sessionUser => {
  const { companyId } = sessionUser
  const { subscription } = companyId

  let companySubscription

  const activeSubscription = subscription && subscription.status === 'Active'
  const isInvoiceSubscription =
    subscription &&
    (subscription.subscriptionId === 'invoice' ||
      subscription.paymentMethodToken === 'invoice')

  const braintreePlanId =
    subscription && !isInvoiceSubscription ? subscription.planId : undefined

  const hasFreeTrial = sessionUser.trialDays > 0
  const hasSingleHires = companyId.singleHires.length > 0

  if (isInvoiceSubscription) {
    companySubscription = 'invoice'
  } else if (braintreePlanId && activeSubscription) {
    companySubscription = braintreePlanId
  } else if (!activeSubscription && hasSingleHires) {
    companySubscription = 'single hire'
  } else if (!activeSubscription && hasFreeTrial) {
    companySubscription = 'free trial'
  } else {
    companySubscription = 'no subscription'
  }

  return companySubscription
}

export const getUserPropertiesForAmplitude = sessionUser => {
  const { _id, user, ...rest } = sessionUser.permissions
  const sessionUserPermissions = rest
  const { companyId } = sessionUser

  let companyData = {}

  if (companyId) {
    const companySubscription =
      getSubscriptionAndSubscriptionStatus(sessionUser)
    const activeFeatures = getCompanyActiveFeatures(companyId)

    companyData = {
      companyId: companyId._id,
      companyName: companyId.name,
      companyDomain: companyId.companyDomain,
      companyCreatedAt: companyId.createdAt,
      companyFeatures: companyId.features,
      companyIntegration: companyId.integrationType,
      companySalesforceId: companyId.salesforceId,
      companyUsesSSO: companyId.hasAuthConfig,
      companySubscription,
      companyHasCustomBranding: activeFeatures.hasCustomBranding,
      companyHasCustomEmailTemplates: activeFeatures.hasCustomEmailTemplates,
      companyHasCustomVideoBackgroundImage: activeFeatures.hasCustomVideoBg,
    }
  }

  const userProperties = {
    createdAt: sessionUser.createdAt,
    permissions: sessionUserPermissions,
    language: sessionUser.language,
    newsletter: sessionUser.newsletter,
    deactivated: sessionUser.deactivated,
    lastAdminAccess: sessionUser.lastAdminAccess,
    beforeBillingEpoch: !sessionUser.isAfterBillingEpoch,
    ...companyData,
  }

  return userProperties
}

export const getCompanyDataForIntercom = sessionUser => {
  const { _id, user, ...rest } = sessionUser.permissions
  const sessionUserPermissions = rest
  const { companyId } = sessionUser
  const { hasCustomBranding, hasCustomEmailTemplates, hasCustomVideoBg } = getCompanyActiveFeatures(companyId)
  let companyData = {}
  const salesforceId = companyId && companyId.salesforceId

  if (companyId) {
    const subscription = getSubscriptionAndSubscriptionStatus(sessionUser)
    const features = getCompanyFeatures(companyId)
    companyData = {
      id: companyId._id,
      name: companyId.name,
      created_at: companyId.createdAt,
      integrationType: companyId.integrationType,
      plan: subscription,
      uses_sso: companyId.hasAuthConfig,
      has_custom_branding: hasCustomBranding,
      has_custom_email_templates: hasCustomEmailTemplates,
      has_custom_virtual_video_background_image: hasCustomVideoBg,
      ...features,
    }
  }

  return { sessionUserPermissions, companyData, salesforceId }
}

export const getIntercomProductTourCode = (path, language) => {
  const lang = language === 'fi' || language === 'se' ? language : 'en'

  switch (path) {
    case INTERCOM_TOURS_PATHS.dashboard: {
      return config.INTERCOM_TOURS[lang].dashboard
    }

    case INTERCOM_TOURS_PATHS.applications: {
      return config.INTERCOM_TOURS[lang].applications
    }

    case INTERCOM_TOURS_PATHS.candidates: {
      return config.INTERCOM_TOURS[lang].candidates
    }

    case INTERCOM_TOURS_PATHS.interviewEdit: {
      return config.INTERCOM_TOURS[lang].interviewEdit
    }

    case INTERCOM_TOURS_PATHS.jobAdEdit: {
      return config.INTERCOM_TOURS[lang].jobAdEdit
    }

    default:
      return path
  }
}

export const getUserMulticompanyBelonging = sessionUser => {
  const { companyId, companiesBelonging } = sessionUser
  return (
    companyId &&
    companyId.name &&
    companiesBelonging &&
    companiesBelonging.length >= 2
  )
}
